export const TEXTS_ACTIVIDAD_ADMINISTRATIVA_DETAIL = {
  es_ES: new Map([
    ['tareas', 'TAREAS ADMINISTRATIVAS'],
    ['tareas_realizadas', 'TAREAS REALIZADAS'],
    ['tareas_pendientes', 'TAREAS PENDIENTES'],
    ['carga_administrativa', 'CARGA ADMINISTRATIVA (meses)'],
    ['reset', 'Restablecer'],
    ['download', 'Descargar'],
    ['tasks', 'Tareas'],
    ['dias', 'Meses'],
    ['mes', 'MES'],
    ['num_usuarios', 'NUMERO DE USUARIOS'],
    ['tipo_tarea', 'TIPO TAREA'],
    ['unidad_administrativa', 'UNIDAD ADMINISTRATIVA'],
    ['ayto', 'AYUNTAMIENTO'],
    ['tipo', 'POR TIPO'],
    ['UA', 'POR UNIDAD ADMINISTRATIVA'],
  ]),
  ca_ES: new Map([
    ['tareas', 'TASQUES ADMINISTRATIVES'],
    ['tareas_realizadas', 'TASQUES REALITZADES'],
    ['tareas_pendientes', 'TASQUES PENDENTS'],
    ['carga_administrativa', 'CARGA ADMINISTRATIVA (mesos)'],
    ['reset', 'Restablir'],
    ['download', 'Descarregar'],
    ['tasks', 'Tasques'],
    ['dias', 'Mesos'],
    ['mes', 'MES'],
    ['num_usuarios', 'NOMBRE D´USUARIS'],
    ['tipo_tarea', 'TIPUS DE TASCA'],
    ['unidad_administrativa', 'UNITAT ADMINISTRATIVA'],
    ['ayto', 'AJUNTAMENT'],
    ['tipo', 'PER TIPUS'],
    ['UA', 'PER UNITAT ADMINISTRATIVA'],
  ]),
};
